import { Box, Grid, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import AirportServicesContext from "../../../../../contexts/AirportServices/AirportServices";
import { useTranslation } from "react-i18next";

export default function SideBar() {
  const { t } = useTranslation();

  const { bookingDetails, airports, selectedAirport, residences } = useContext(
    AirportServicesContext
  );

  const [serviceDetails, setServiceDetails] = useState(null);

  useEffect(() => {
    const foundAirport = airports.find(
      (airport) => airport?.service_id === bookingDetails?.service_id
    );
    const foundResidence = residences.find(
      (residence) => residence?.id === bookingDetails?.residence_id
    );
    setServiceDetails({
      service_name: foundAirport.service_name,
      residence_name: foundResidence.name,
    });
  }, [airports, residences, bookingDetails]);

  // useEffect(() => {
  // }, [serviceDetails]);
  return (
    <Box
      sx={{
        position: "sticky",
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px",
        borderRadius: "1rem",
        padding: "1.5rem",
      }}
    >
      <Box
        sx={{
          borderBottom: "1px solid #efefef",
          marginBottom: "1rem",
          paddingBottom: "1rem",
        }}
      >
        <Typography textTransform={"capitalize"} variant="h6" color={"primary"}>
          {t("airportTransfer.from")}
        </Typography>
        <Typography>
          {bookingDetails?.travel_type === "Arrival"
            ? serviceDetails?.service_name
            : serviceDetails?.residence_name}
        </Typography>
      </Box>

      <Box
        sx={{
          borderBottom: "1px solid #efefef",
          marginBottom: "1rem",
          paddingBottom: "1rem",
        }}
      >
        <Typography textTransform={"capitalize"} variant="h6" color={"primary"}>
          {t("airportTransfer.to")}
        </Typography>
        <Typography>
          {bookingDetails?.travel_type === "Arrival"
            ? serviceDetails?.residence_name
            : serviceDetails?.service_name}
        </Typography>{" "}
      </Box>

      <Box
        sx={{
          borderBottom: "1px solid #efefef",
          marginBottom: "1rem",
          paddingBottom: "1rem",
        }}
      >
        <Typography textTransform={"capitalize"} variant="h6" color={"primary"}>
          {t("person")}
        </Typography>
        <Typography>{bookingDetails?.people_count}</Typography>
      </Box>

      <Box>
        <Typography textTransform={"capitalize"} variant="h6" color={"primary"}>
          {t("travelType")}
        </Typography>
        <Typography>{bookingDetails?.travel_type}</Typography>
      </Box>
    </Box>
  );
}
